var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar__overlay",class:[{ opened: _vm.showSidebar }],on:{"click":function($event){return _vm.closesidebar()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }